import React from 'react';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

const NotificationsHistoricListHeader = ({
  canAdd = false,
  companyId = '',
  subcompanyId = '',
  t,
}) => {
  return (
    <Common.Header title={t('notification_historic.title')}>
      <div className="btn-group pull-right">
        {canAdd && (
          <Form.Link
            to={createRoute(companyId, subcompanyId, 'notifications_historic/add')}
            className="btn btn-info"
          >
            {t('actions.add')}
          </Form.Link>
        )}
      </div>
    </Common.Header>
  );
};

export default translate()(NotificationsHistoricListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/list/NotificationsHistoricListHeader.js